<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="backToAgencies()"
                v-bind="attrs"
                v-on="on"
                color="primary"
                dense
                icon
              >
                <v-icon>mdi-arrow-left-bold-circle</v-icon>
              </v-btn>
            </template>
            <span>Back To Subscription</span>
          </v-tooltip>
        </v-col>
        <v-col cols="11">
          <h2>Agency: {{ agencyProfile.agencyName }}</h2>
        </v-col>

        <v-col cols="12" sm="12" md="3" lg="3">
          <v-card flat class="py-3 px-3">
            <v-row>
              <v-col cols="12">
                <h3>Subscriptions & Reports</h3>
              </v-col>
              <v-col cols="12" class="hidden-sm-and-down">
                <v-list class="py-0">
                  <v-list-item-group>
                    <v-list-item
                      @click="menuActionClick('activeSubscriptions')"
                      dense
                    >
                      <v-list-item-icon>
                        <v-icon color="danetest">mdi-account-multiple</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="danetest--text"
                          >Active Subscriptions</v-list-item-title
                        >
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      @click="menuActionClick('cancelledSubscriptions')"
                      dense
                    >
                      <v-list-item-icon>
                        <v-icon color="danetest">mdi-account-remove</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="danetest--text"
                          >Cancelled Subscriptions</v-list-item-title
                        >
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      @click="menuActionClick('activeDemoReports')"
                      dense
                    >
                      <v-list-item-icon>
                        <v-icon color="danetest">mdi-account-remove</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="danetest--text"
                          >Demo Reports</v-list-item-title
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
              <v-col cols="12" class="py-0 hidden-sm-and-up">
                <v-select
                  v-model="selectedItem"
                  @change="menuActionClick(selectedItem)"
                  :items="viewItems"
                  label="Select Items To View"
                  item-text="name"
                  item-value="action"
                ></v-select>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col
          v-if="
            selectedSubscription == '' && activeSubscriptions && !isLoadingSub
          "
          cols="12"
          sm="12"
          md="9"
          lg="9"
        >
          <v-card flat class="py-3 px-3">
            <generalAlert
              v-if="alert"
              :alert="alert"
              :alertType="alertType"
              :message="successResponse"
            />
            <v-row>
              <v-col cols="12">
                <h3>Active Subscriptions</h3>
              </v-col>
              <v-col cols="12">
                <v-card class="py-3 px-3">
                  <v-card-title>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search Clients"
                      single-line
                      hide-details
                    ></v-text-field>
                    <v-spacer></v-spacer>
                  </v-card-title>
                  <v-data-table
                    :headers="headers"
                    :items="agencyActiveSubscriptions"
                    :search="search"
                    :items-per-page="5"
                    :loading="isLoading"
                    loading-text="Loading... Please wait"
                  >
                    <template v-slot:[`item.package`]="{ item }">
                      {{ item.package.currentPackage }}
                      <!-- {{ item.pageNames.map(page => page.name).join(', ') }} -->
                      <!-- <p v-for="page in item.package.pages" :key="page.id"> {{ page.name  }}</p> -->
                    </template>
                    <template v-slot:[`item.isActive`]="{ item }">
                      <v-chip class="ma-2" color="success"> Active </v-chip>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <v-btn
                        @click="viewSubscription(item)"
                        icon
                        color="primary"
                        ><v-icon>mdi-eye</v-icon></v-btn
                      >
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col
          v-if="
            selectedSubscription == '' &&
            cancelledSubscriptions &&
            !isLoadingSub
          "
          cols="12"
          sm="12"
          md="9"
          lg="9"
        >
          <v-card flat class="py-3 px-3">
            <generalAlert
              v-if="alert"
              :alert="alert"
              :alertType="alertType"
              :message="successResponse"
            />
            <v-row>
              <v-col cols="12">
                <h3>Cancelled Subscriptions</h3>
              </v-col>
              <v-col cols="12">
                <v-card class="py-3 px-3">
                  <v-card-title>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search Clients"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-data-table
                    :headers="headers"
                    :items="agencyInactiveSubscriptions"
                    :search="search"
                    :items-per-page="5"
                    :loading="isLoading"
                    loading-text="Loading... Please wait"
                  >
                    <template v-slot:[`item.pageNames`]="{ item }">
                      <p class="mb-0">{{ item.pageNames }}</p>
                    </template>
                    <template v-slot:[`item.isActive`]="{ item }">
                      <v-chip class="ma-2" color="error"> Inactive </v-chip>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <v-btn
                        @click="viewSubscription(item)"
                        icon
                        color="primary"
                        ><v-icon>mdi-eye</v-icon></v-btn
                      >
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col
          v-if="
            selectedSubscription == '' && activeDemoReports && !isLoadingSub
          "
          cols="12"
          sm="12"
          md="9"
          lg="9"
        >
          <v-card flat class="py-3 px-3">
            <generalAlert
              v-if="alert"
              :alert="alert"
              :alertType="alertType"
              :message="successResponse"
            />
            <v-row>
              <v-col cols="12">
                <h3>Demo Reports</h3>
              </v-col>
              <v-col cols="12">
                <v-card class="py-3 px-3">
                  <v-card-title>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search Clients"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-data-table
                    :headers="demoHeaders"
                    :items="demoReports"
                    :search="search"
                    :items-per-page="5"
                    :loading="isLoading"
                    loading-text="Loading... Please wait"
                  >
                    <template v-slot:[`item.action`]="{ item }">
                      <v-btn @click="viewDemoReport(item)" icon color="primary"
                        ><v-icon>mdi-eye</v-icon></v-btn
                      >
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// import axios from 'axios';
import editSubscriptionInfo from "../components/dialogs/editSubscriptionInfo.vue";
import editSubscriptionPackageInfo from "../components/dialogs/editSubscriptionPackageInfo.vue";
import testEditPackage from "../components/dialogs/testEditPackage.vue";
import generalAlert from "../components/alerts/generalAlert.vue";

import { firebaseApp } from "../firebaseConfig";
import {
  getFirestore,
  doc,
  getDoc,
  query,
  collection,
  where,
  getDocs,
} from "firebase/firestore";
const db = getFirestore(firebaseApp);

import moment from "moment-timezone";

export default {
  props: ["id"],
  components: {
    editSubscriptionInfo,
    editSubscriptionPackageInfo,
    testEditPackage,
    // testingSidePopup,
    generalAlert,
  },
  data: () => ({
    // overlay:false,
    selectedItem: "",
    agencyActiveSubscriptions: [],
    agencyInactiveSubscriptions: [],
    demoReports: [],
    agencyProfile: [],
    signedIn: "",
    activeSubscriptions: true,
    cancelledSubscriptions: false,
    activeDemoReports: false,
    isLoadingSub: false,
    pageSearch: "danetopham",
    columnSize: 8,
    columnSize1: 4,
    selectedSubscription: [],
    isLoading: false,
    loggedIn: true,
    search: "",
    tab: null,
    alert: false,
    alertType: "",
    successResponse: "",
    items: [
      { tab: "Competitive Analysis", content: "Tab 1 Content" },
      { tab: "FB Analytics", content: "Tab 2 Content" },
      { tab: "Brand Reports", content: "Tab 3 Content" },
    ],
    viewItems: [
      { name: "Active Subscriptions", action: "activeSubscriptions" },
      { name: "Cancelled Subscriptions", action: "cancelledSubscriptions" },
      { name: "Demo Reports", action: "activeDemoReports" },
    ],
    headers: [
      {
        text: "Client",
        value: "name",
        sortable: false,
        align: "center",
      },
      {
        text: "Company",
        sortable: false,
        value: "package.primaryPage.name",
        align: "center",
      },
      {
        text: "Package",
        sortable: false,
        value: "package",
        align: "center",
      },
      {
        text: "Date Created",
        value: "dateCreated",
        sortable: false,
        align: "center",
      },
      {
        text: "Status",
        value: "isActive",
        sortable: false,
        align: "center",
      },
      {
        text: "Action",
        value: "action",
        sortable: false,
        align: "center",
      },
    ],
    demoHeaders: [
      {
        text: "Client",
        value: "prospectingClientName",
        sortable: false,
        width: "10%",
        align: "center",
      },
      {
        text: "Email",
        sortable: false,
        value: "prospectingClientEmail",
        width: "15%",
        align: "center",
      },
      {
        text: "Date Created",
        value: "createdAt",
        sortable: false,
        width: "10%",
        align: "center",
      },
      {
        text: "Expires At",
        value: "expiresAt",
        sortable: false,
        width: "10%",
        align: "center",
      },
      {
        text: "Action",
        value: "action",
        sortable: false,
        width: "10%",
        align: "center",
      },
    ],
    cancelledSubscriptionsList: [
      {
        image: "../../assets/haha.png",
        company: "Candice Motors",
        package: "Package 1",
        pageNames: "BMW, Mercedes, Audi",
        emailAddress: "danetopham@gmail.com",
        dateStarted: "19/01/2023",
        uid: "212412421412141412",
        status: false,
      },
      {
        image: "../../assets/haha.png",
        company: "Simon Motors",
        package: "Package 2",
        pageNames: "Honda, Ford, Audi",
        emailAddress: "tophamdane@gmail.com",
        dateStarted: "19/01/2023",
        uid: "212412421412141412",
        status: false,
      },
    ],
    reports: [],
  }),
  filters: {
    formatDate: function (value) {
      return moment(value).format("dddd, MMMM Do YYYY");
    },
  },
  created() {
    this.getAgencyInfo();
  },
  methods: {
    async getAgencyInfo() {
      this.isLoading = true;
      // this.overlay = true
      try {
        const docRef = doc(db, "agencies", this.id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          this.agencyProfile = docSnap.data();
          this.getAgencySubscriptions();
        } else {
          console.log("No such document!");
          this.isLoading = false;
        }
      } catch (err) {
        this.isLoading = false;
        console.log("getAgencyInfo err", err);
      }
    },
    async getAgencySubscriptions() {
      this.agencyActiveSubscriptions = [];
      this.agencyInactiveSubscriptions = [];
      try {
        const q = query(
          collection(db, "subscriptions"),
          where("agencyId", "==", this.id)
        );
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          let subscription = doc.data();

          //format Date
          let createdMilliseconds = subscription.dateCreated;
          let formatCreatedDate =
            moment(createdMilliseconds).format("YYYY-MM-DD");
          subscription.dateCreated = formatCreatedDate;

          if (subscription.isActive == true) {
            //Push item to array
            this.agencyActiveSubscriptions.push(subscription);
          } else {
            // Format the date
            this.agencyInactiveSubscriptions.push(subscription);
          }
        });
        this.getAgencyDemos();
        // this.overlay = false
      } catch (err) {
        console.log("getAgencySubscriptions err", err);
        this.isLoading = false;
      }
    },
    async getAgencyDemos() {
      this.demoReports = [];
      try {
        const q = query(
          collection(db, "demoreports"),
          where("agencyId", "==", this.id)
        );
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          let demoReport = doc.data();

          //format Date
          let createdDemoMilliseconds = demoReport.createdAt;
          let formatDemoCreatedDate = moment(createdDemoMilliseconds).format(
            "YYYY-MM-DD"
          );
          demoReport.createdAt = formatDemoCreatedDate;

          let expiryMilliseconds = demoReport.expiresAt;
          let formatExpiresDate =
            moment(expiryMilliseconds).format("YYYY-MM-DD");
          demoReport.expiresAt = formatExpiresDate;

          this.demoReports.push(demoReport);
        });
        this.isLoading = false;
        // this.overlay = false
      } catch (err) {
        console.log("getAgencySubscriptions err", err);
        this.isLoading = false;
      }
    },
    login() {
      this.loggedIn = !this.loggedIn;
    },
    menuActionClick(action) {
      if (action == "activeSubscriptions") {
        this.activeSubscriptions = true;
        this.cancelledSubscriptions = false;
        this.activeDemoReports = false;
        this.selectedSubscription = [];
      } else if (action == "cancelledSubscriptions") {
        this.cancelledSubscriptions = true;
        this.activeSubscriptions = false;
        this.activeDemoReports = false;
        this.selectedSubscription = [];
      } else if (action == "activeDemoReports") {
        this.cancelledSubscriptions = false;
        this.activeSubscriptions = false;
        this.activeDemoReports = true;
        this.selectedSubscription = [];
      }
    },
    successAlert(message, typeOfAlert) {
      this.successResponse = message;
      this.alertType = typeOfAlert;
      this.alert = true;

      setTimeout(() => {
        this.getAgencyInfo();
        this.alert = false;
      }, 2000);
    },
    backToAgencies() {
      this.$router.push({
        name: "agencies",
      });
    },
    viewSubscription(item) {
      this.$router.push({
        name: "singleSubscription",
        params: {
          id: item.agencyId,
          uid: item.uid,
        },
      });
    },
    viewDemoReport(item) {
      this.$router.push({
        name: "demoReport",
        params: {
          reportId: item.reportId,
        },
      });
    },
  },
};
</script>

<style>
/* .theme--light.v-tabs > .v-tabs-bar {
  background-color: #3d6eb1 !important;
} */
</style>
